"use client";

import "./UiUxContactSection.scss";
import ContactForm from "@/components/ContactForm/ContactForm";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaRegCircleCheck } from "react-icons/fa6";
const UiUxContactSection = ({ contact }) => {
  const { title, description, features= [] } = contact;


  return (
    <section className="uiux-cta-section">
      <Container>
        <Row className="align-items-center">
          <Col xxl={6} xl={6} lg={6}>
            <div className="erp-cta-content">
              <h2>{title}</h2>
              <p>{description}</p>

              <div className="cta-features">
                {features.map((item, index) => (
                  <div className="feature-item" key={index}>
                    <div className="feature-icon">
                      <FaRegCircleCheck />
                    </div>

                    <p>{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </Col>

          <Col xxl={6} xl={6} lg={6} data-aos="zoom-in">
            <ContactForm />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default UiUxContactSection;
